import { getPools } from "../../../../api/pools";

import { getEmployees } from "../../../../api/employees";
import { getContracts } from "../../../../api/contract";

export const MASTER_FIELDS = [
  { key: "name", label: "Name" },
  // { key: "description", label: "Description" },
  {
    key: "parent_id",
    label: "Parent Pool",
    type: "select",
    apiResKey: "pools",
    api: getPools,
  },

  {
    key: "employees",
    label: "Employees",
    type: "select",
    apiResKey: "employees",
    api: getEmployees,
    isMulti: true
  },

  {
    key: "company_contracts",
    label: "Contract",
    type: "select",
    apiResKey: "company_contracts",
    api: getContracts,
  },
];

const FIELDS = [...MASTER_FIELDS];

export default FIELDS;
